module.exports = __webpack_public_path__ + "img/radish.c3cdaef7.gif";